import { ProfileInfoFieldType } from '../ProfileInfoWidget.constants'

export const SINGLE_LINE_TYPES = [
  ProfileInfoFieldType.BIC,
  ProfileInfoFieldType.EMAIL,
  ProfileInfoFieldType.IBAN,
  ProfileInfoFieldType.INPUT,
]
